// extracted by mini-css-extract-plugin
export default {"loader":"lazyLoaderFallback_loader__6VCpp"};